"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const UserIdentifyingField_vue_1 = tslib_1.__importDefault(require("./UserIdentifyingField.vue"));
const ScenarioType_1 = require("../../enums/ScenarioType");
exports.default = vue_1.default.extend({
    name: 'user-identifying-field-group',
    props: {
        index: {
            type: Number,
            default: 0,
        },
        name: {
            type: String,
            default: '',
        },
        fields: {
            type: Array,
            default: () => [],
        },
        scenarioType: {
            type: Number,
            default: 0,
        },
        scenarioName: {
            type: String,
            default: '',
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        textForGroup(scenarioType, index) {
            const bankName = this.$store.state.configuration.bankName;
            return this.getSiteText(`${ScenarioType_1.ScenarioType[scenarioType]}.UserIdentifyingFieldGroup.${index + 1}.Text`, bankName);
        },
        validationCheck(data) {
            this.$emit('validation-check', data);
        },
    },
    components: {
        UserIdentifyingField: UserIdentifyingField_vue_1.default,
    },
});
